import React from "react"
import { Flex, Box, Heading } from "rebass/styled-components"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import { StyledLink } from "../common"

const LatestPosts = () => {
  const data = useStaticQuery(graphql`
    {
      allNodeBlogPost(limit: 3, sort: { created: DESC }) {
        edges {
          node {
            id
            title
            path {
              alias
            }
            relationships {
              field_media {
                relationships {
                  field_media_image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          width: 500
                          height: 400
                          layout: CONSTRAINED
                        )
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)
  return (
    <Box>
      <Heading textAlign="center" mb={[1, 2, 3]}>
        Последнее в блоге
      </Heading>
      <Flex
        flexWrap="wrap"
        justifyContent="space-between"
        alignItems="stretch"
        mx={[-1, -2]}
      >
        {data?.allNodeBlogPost?.edges?.map(({ node }) => (
          <Box p={[1, 2]} width={[1, 0.5, 0.3333]} mb={[2, 3]} key={node?.id}>
            <Box backgroundColor="gray.100" p={2} height="100%">
              <Heading mb={[2]}>{node?.title}</Heading>
              {node?.relationships?.field_media && (
                <GatsbyImage
                  image={
                    node?.relationships?.field_media?.relationships
                      ?.field_media_image?.localFile?.childImageSharp
                      ?.gatsbyImageData
                  }
                />
              )}
              <StyledLink to={node.path.alias}>Читать дальше</StyledLink>
            </Box>
          </Box>
        ))}
      </Flex>
    </Box>
  )
}

export default LatestPosts
